import axios from "axios";
import { logger } from "../utilities/logger";
const URL = window.RUNTIME_CONFIG.API_BASE_URL;
const BASE_URL = `${URL}/user`;

export class LoginService {
  static async SignIn(email, pass) {
    try {
      const response = await axios.post(`${BASE_URL}/signin`, { email, pass }, {
        headers: { "ngrok-skip-browser-warning": "true" },
      });
      return response.data;
    } catch (err) {
      logger.error("SignIn failed:", err.response?.data ?? err.message);
      throw err;
    }
  }

  static async CheckEmailExistOrNot(email) {
    try {
      const response = await axios.get(`${BASE_URL}/checkemail?email=${email}`, {
        headers: { "ngrok-skip-browser-warning": "true" },
      });
      return response.data;
    } catch (err) {
      logger.error("CheckEmailExistOrNot failed:", err.response?.data ?? err.message);
      throw err;
    }
  }

  static async ResetPassword(email, pass) {
    try {
      const response = await axios.post(`${BASE_URL}/resetpassword`, { email, pass }, {
        headers: { "ngrok-skip-browser-warning": "true" },
      });
      return response.data;
    } catch (err) {
      logger.error("ResetPassword failed:", err.response?.data ?? err.message);
      throw err;
    }
  }

  static async GetAllDesigerName() {
    try {
      const response = await axios.get(`${BASE_URL}/getalldesignername`, {
        headers: { "ngrok-skip-browser-warning": "true" },
      });
      return response.data;
    } catch (err) {
      logger.error("GetAllDesigerName failed:", err.response?.data ?? err.message);
      throw err;
    }
  }
}
